import type RootState from 'app-components/utils/redux-store/rootState';

import {
  POSTPONED_ACTIONS_REDUCER_KEY,
  type PostponedActions,
  type PostponedActionsStore,
} from './postponedActionsTypes';

type State = Pick<RootState, typeof POSTPONED_ACTIONS_REDUCER_KEY>;

const getStore = (state: State): PostponedActionsStore => state[POSTPONED_ACTIONS_REDUCER_KEY];

export const getPostponedActions = (state: State): PostponedActions => getStore(state).postponedActions;
